import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row g-xl-5 g-3" }

import { ref, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n';
import { addMenuPageLanguage } from '@/core/locales/page-list-language';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAddMenupage',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const addmenupage = defineAsyncComponent (() => import ("@/components/theme/ecommerce/addpagelist/addmenupage.vue"))
const { t } = useI18n({
    messages: addMenuPageLanguage
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-sm-12",
        text: "true",
        headerTitle: "true",
        title: _unref(t)('AddEditPage')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(addmenupage))
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})